export const getCabinClass = (classOfServices) => {
    if (!classOfServices) return '';

    if (classOfServices.CabinType?.toUpperCase() === 'ECONOMY') {
        return 'Classe Econômica';
    }
    if (classOfServices.CabinType?.toUpperCase() === 'BUSINESS') {
        return 'Classe Executiva';
    }
    if (classOfServices.CabinType?.toUpperCase() === 'PREMIUMECONOMY') {
        return 'Classe PremiumEconomy';
    }
    if (classOfServices.CabinType?.toUpperCase() === 'FIRSTCLASS') {
        return 'Primeira Classe';
    }

    let search = (classOfServices.CabinType || '').toUpperCase();
    if (classOfServices.FareFamilyName) {
        search += (classOfServices.FareFamilyName || '').toUpperCase();
    }
    if (classOfServices.FareFamily) {
        search += (classOfServices.FareFamily || '').toUpperCase();
    }
    if (classOfServices.FamilyRules?.FamilyName) {
        search += (classOfServices.FamilyRules.FamilyName || '').toUpperCase();
    }
    if (classOfServices.FamilyRules?.FamilyDescription) {
        search += (classOfServices.FamilyRules.FamilyDescription || '').toUpperCase();
    }

    if (search.includes('FIRST')) {
        return 'Primeira Classe';
    } else if (search.includes('BUSINESS') || search.includes('EJECUPROM') || search.includes('EJECUTIVA')) {
        return 'Classe Executiva';
    }

    if (search.includes('ECONOMY')) {
        return 'Classe Econômica';
    }

    return '';
};

export const formatTime = (time) => {
    switch (time) {
        case 'Morning':
            return 'Manhã';
        case 'Afternoon':
            return 'Tarde';
        case 'Dusk':
            return 'Noite';
        case 'Dawn':
            return 'Madrugada';
        default:
            return time;
    }
}

export const formatDate = (dateString, withYear = false) => {
    const date = new Date(dateString);
    const days = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];
    const months = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

    const dayOfWeek = days[date.getUTCDay()];
    const day = date.getUTCDate();
    const month = months[date.getUTCMonth()];
    const year = date.getUTCFullYear();

    if (withYear) {
        return `${dayOfWeek} ${day} ${month} ${year}`;
    } else {
        return `${dayOfWeek} ${day} ${month}`;
    }
};
